import { Helmet } from "react-helmet-async";

type HeadProps = {
  title?: string;
  description?: string;
};

export const Head = ({ title = "", description = "" }: HeadProps = {}) => {
  return (
    <Helmet title="CTRG Portal" defaultTitle="CTRG Portal">
      <meta name="description" content="CTRG Portal" />
    </Helmet>
  );
};
